"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHomeDOIDocumentVersion = exports.HomeDocVersionEnum = exports.CollapseTextWidget = exports.PluginTemplates = exports.PageValidationMessage = exports.PriceTransparencyWidget = exports.AutomaticRenewalCancellationConfirmationModal = exports.InfoModal = exports.ConfirmModal = exports.AutoRenewalBenefits = exports.AnnualHomeDocumentListModal = exports.WebChatPopUp = exports.TrustLogoComponent = exports.StickyHelpButtonPopup = exports.PolicySummaryPriceWidget = exports.DocumentListModal = exports.MaintenanceBannerWidget = exports.FalconSlider = void 0;
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var GuardErrorPage_1 = require("./pages/GuardErrorPage");
var FalconJourneyRenderingPage_1 = require("./pages/FalconJourneyRenderingPage");
var ApplicationErrorPage_1 = require("./pages/ApplicationErrorPage");
var renters_1 = require("./widgets/subscription/renters");
var motor_1 = require("./widgets/subscription/motor");
var motor_2 = require("./widgets/annual/motor");
var renters_2 = require("./commands/subscription/renters");
var motor_3 = require("./commands/subscription/motor");
var FalconSlider_1 = require("./components/FalconSlider");
Object.defineProperty(exports, "FalconSlider", { enumerable: true, get: function () { return FalconSlider_1.FalconSlider; } });
var Types_1 = require("./Types");
var ChangelogRecorder_1 = require("./services/ChangelogRecorder");
var FalconCommandsExecutor_1 = require("./services/FalconCommandsExecutor");
var falconSelfService_1 = require("./widgets/falconSelfService");
var motor_4 = require("./commands/annual/motor");
var commands_1 = require("./commands");
var motorCommon_1 = require("./widgets/motorCommon");
var payments_1 = require("./widgets/payments");
var subscription_1 = require("./widgets/subscription");
var navigator_1 = require("./navigator");
var directDebit_1 = require("./widgets/directDebit");
var widgets_1 = require("./widgets");
var home_1 = require("./widgets/annual/home");
var common_1 = require("./widgets/annual/common");
var MaintenanceBannerWidget_1 = require("./widgets/MaintenanceBannerWidget");
Object.defineProperty(exports, "MaintenanceBannerWidget", { enumerable: true, get: function () { return MaintenanceBannerWidget_1.MaintenanceBannerWidget; } });
var DocumentListModal_1 = require("./widgets/annual/motor/DocumentListModal");
Object.defineProperty(exports, "DocumentListModal", { enumerable: true, get: function () { return DocumentListModal_1.DocumentListModal; } });
var PolicySummaryPriceWidget_1 = require("./widgets/PolicySummaryPriceWidget");
Object.defineProperty(exports, "PolicySummaryPriceWidget", { enumerable: true, get: function () { return PolicySummaryPriceWidget_1.PolicySummaryPriceWidget; } });
var StickyHelpButtonPopup_1 = require("./components/modals/StickyHelpButtonPopup");
Object.defineProperty(exports, "StickyHelpButtonPopup", { enumerable: true, get: function () { return StickyHelpButtonPopup_1.StickyHelpButtonPopup; } });
var TrustLogoComponent_1 = require("./widgets/TrustLogoComponent");
Object.defineProperty(exports, "TrustLogoComponent", { enumerable: true, get: function () { return TrustLogoComponent_1.TrustLogoComponent; } });
var WebChatPopUp_1 = require("./components/modals/WebChatPopUp");
Object.defineProperty(exports, "WebChatPopUp", { enumerable: true, get: function () { return WebChatPopUp_1.WebChatPopUp; } });
var AnnualHomeDocumentListModal_1 = require("./widgets/annual/home/AnnualHomeDocumentListModal");
Object.defineProperty(exports, "AnnualHomeDocumentListModal", { enumerable: true, get: function () { return AnnualHomeDocumentListModal_1.AnnualHomeDocumentListModal; } });
var AutoRenewalBenefits_1 = require("./helpers/AutoRenewalBenefits");
Object.defineProperty(exports, "AutoRenewalBenefits", { enumerable: true, get: function () { return AutoRenewalBenefits_1.AutoRenewalBenefits; } });
var ConfirmModal_1 = require("./components/modals/ConfirmModal");
exports.ConfirmModal = ConfirmModal_1.default;
var InfoModal_1 = require("./components/modals/InfoModal");
Object.defineProperty(exports, "InfoModal", { enumerable: true, get: function () { return InfoModal_1.InfoModal; } });
var AutomaticRenewalCancellationConfirmationModal_1 = require("./components/modals/AutomaticRenewalCancellationConfirmationModal");
Object.defineProperty(exports, "AutomaticRenewalCancellationConfirmationModal", { enumerable: true, get: function () { return AutomaticRenewalCancellationConfirmationModal_1.AutomaticRenewalCancellationConfirmationModal; } });
var PriceTransparencyWidget_1 = require("./widgets/annual/motor/priceTransparency/PriceTransparencyWidget");
Object.defineProperty(exports, "PriceTransparencyWidget", { enumerable: true, get: function () { return PriceTransparencyWidget_1.PriceTransparencyWidget; } });
var PageValidationMessage_1 = require("./helpers/PageValidationMessage");
Object.defineProperty(exports, "PageValidationMessage", { enumerable: true, get: function () { return PageValidationMessage_1.PageValidationMessage; } });
var PluginTemplates_1 = require("./PluginTemplates");
Object.defineProperty(exports, "PluginTemplates", { enumerable: true, get: function () { return PluginTemplates_1.PluginTemplates; } });
var CollapseTextWidget_1 = require("./components/CollapseTextWidget");
Object.defineProperty(exports, "CollapseTextWidget", { enumerable: true, get: function () { return CollapseTextWidget_1.CollapseTextWidget; } });
var plugin = {
    getName: function () {
        return "plugin-falcon-journey";
    },
    register: function (extensions, configuration) {
        // Routes
        extensions.routes.rebind({
            path: "/journey/:action/product/:product/process/:process/:pageId?/:interactionId?",
            component: FalconJourneyRenderingPage_1.FalconPluginJourneyRenderingPage,
        });
        // Widgets
        (0, widgets_1.addBaseWidgets)(extensions);
        (0, renters_1.addRentersWidgets)(extensions);
        (0, motor_1.addMotorWidgets)(extensions);
        (0, falconSelfService_1.addFalconSSWidgets)(extensions);
        (0, common_1.addAnnualCommonWidgets)(extensions);
        (0, motor_2.addAnnualMotorWidgets)(extensions);
        (0, home_1.addAnnualHomeWidgets)(extensions);
        (0, motorCommon_1.addCommonMotorWidgets)(extensions);
        (0, payments_1.addPaymentsWidgets)(extensions);
        (0, subscription_1.addCommonSubscriptionWidgets)(extensions);
        (0, directDebit_1.addDirectDebitWidgets)(extensions);
        // Services
        extensions.services.bind(services_1.Types.CacheManager).to(services_1.FalconCacheManager).inSingletonScope();
        extensions.services.bind(services_1.Types.FalconConvenienceApiService).to(services_1.FalconConvenienceApiServiceImpl);
        extensions.services.bind(services_1.Types.FalconConvenienceApiServiceConfig).toConstantValue(configuration.falconConvenienceApiService);
        extensions.services.rebind(plugin_journey_1.Types.LookupService).to(services_1.FalconLookupService);
        // Navigators
        (0, navigator_1.addNavigators)(extensions);
        // Commands
        (0, motor_3.addMotorCommands)(extensions);
        (0, renters_2.addRentersCommands)(extensions);
        (0, motor_4.addAnnualMotorCommands)(extensions);
        (0, commands_1.addCommonCommands)(extensions);
        extensions.routes.add({
            path: "/keycloakFeedback",
            component: GuardErrorPage_1.GuardErrorPage,
        });
        extensions.routes.add({
            path: "/error",
            component: ApplicationErrorPage_1.ApplicationErrorPage,
        });
        extensions.routes.rebind({
            path: "/sessionExpired",
            component: GuardErrorPage_1.GuardErrorPage,
        });
        extensions
            .services
            .bind(services_1.Types.NotificationService)
            .to(services_1.NotificationService)
            .inSingletonScope();
        extensions
            .services
            .bind(Types_1.Types.ChangelogRecorder)
            .to(ChangelogRecorder_1.ChangelogRecorder)
            .inSingletonScope();
        extensions
            .services
            .rebind(plugin_journey_1.Types.CommandsExecutor)
            .to(FalconCommandsExecutor_1.FalconCommandsExecutor)
            .inSingletonScope();
        (0, services_1.registerValidators)(extensions.services.get(core_1.TypeDefs.JourneyComponentsManager));
    },
};
exports.default = plugin;
__exportStar(require("./widgets/SectionPanelTags"), exports);
__exportStar(require("./widgets/annual/motor/DocumentListModal"), exports);
__exportStar(require("./commonFunctions"), exports);
__exportStar(require("./components/modals/renderers/PricingExplainedRenderers"), exports);
__exportStar(require("./components/modals/renderers/RentersPricingExplainedRenderers"), exports);
__exportStar(require("./widgets/annual/home/directDebit/DirectDebitFunctions"), exports);
__exportStar(require("./widgets/annual/home/AnnualHomeDocumentListModal"), exports);
__exportStar(require("./components/carousel/Carousel"), exports);
__exportStar(require("./components/carousel/CarouselBanner"), exports);
var AnnualHomeDocumentListModal_2 = require("./widgets/annual/home/AnnualHomeDocumentListModal");
Object.defineProperty(exports, "HomeDocVersionEnum", { enumerable: true, get: function () { return AnnualHomeDocumentListModal_2.HomeDocVersionEnum; } });
Object.defineProperty(exports, "getHomeDOIDocumentVersion", { enumerable: true, get: function () { return AnnualHomeDocumentListModal_2.getHomeDOIDocumentVersion; } });
//# sourceMappingURL=index.js.map